import { useState, useEffect } from 'react';

const LS_MODE  = 'littoral_dark_mode';
const LS_THEME = 'littoral_dark_theme';
const DEFAULT  = 'dark-graphite';

export function useTheme() {
  const [isDark,    setIsDark]    = useState(() => localStorage.getItem(LS_MODE)  === 'true');
  const [darkTheme, setDarkState] = useState(() => localStorage.getItem(LS_THEME) || DEFAULT);

  useEffect(() => {
    if (isDark) {
      document.documentElement.setAttribute('data-theme', darkTheme);
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
  }, [isDark, darkTheme]);

  function toggleDark() {
    const next = !isDark;
    setIsDark(next);
    localStorage.setItem(LS_MODE, String(next));
  }

  function setDarkTheme(key) {
    setDarkState(key);
    localStorage.setItem(LS_THEME, key);
  }

  return { isDark, toggleDark, darkTheme, setDarkTheme };
}
